// One definition for the card that wraps a data table.
//
// These wrappers had drifted into five variants across the list pages: three
// shadows (shadow-card / shadow-custom / table-shadow — the last of which is not  // class-guard-allow
// defined anywhere, so those cards had no shadow at all), two radii, and
// bg-surface missing on Users and Affiliates, which left those tables sitting
// transparent on the page background.
//
// Import this instead of retyping the classes, so the next table cannot drift.
// `table-card` is the hook for the first/last column inset in index.css - without
// it the outer columns sit flush against the card edge and the last header clips.
export const TABLE_CARD = 'table-card bg-surface border border-divider rounded-2xl shadow-card dark:shadow-none overflow-hidden'

// Header row of a hand-rolled <table>: a light grey band that separates the
// titles from the rows. Was hardcoded as #F6F6F9 in three tables and absent from
// the rest; --color-bg-subtle carries it in both themes.
export const TABLE_HEAD_ROW = 'text-text-secondary bg-[var(--color-bg-subtle)] border-b border-divider'

// The same band for MUI TableCell sx blocks, which cannot take a Tailwind class.
export const TABLE_HEAD_CELL_SX = {
  fontSize: '13px',
  textTransform: 'uppercase',
  fontWeight: 600,
  color: 'text.secondary',
  backgroundColor: 'var(--color-bg-subtle)',
  borderBottom: 1,
  borderColor: 'divider',
  px: '10px',
  py: 0,
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  lineHeight: 1,
}

// Header cell typography, matched to the MUI headerCellSx used elsewhere.
export const TABLE_HEAD_CELL = 'text-left font-semibold text-sm uppercase text-text-secondary'

// A table nested inside another card (the contact record's tabs). Same border,
// radius and column gutters as a top-level table card, minus the shadow - a
// shadow inside a card reads as a second, floating surface. Matches History,
// which is the reference for this pattern.
export const TABLE_CARD_INNER = 'table-card bg-surface border border-divider rounded-xl overflow-hidden'
